// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"57":"index","594":"about","794":"statement"}[chunkId] || chunkId) + "." + {"57":"477eb924","514":"4e6a3d81","594":"36ba47d0","794":"06e73524"}[chunkId] + ".js";
};